import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { useRecoilValue } from 'recoil';
import { themeSelector } from '@/state/config';
import { isMobileSelector } from '@/state/session';
import styles from './ResponseWrapper.module.scss';
export const ResponseWrapper = ({ children, className, }) => {
    const isMobile = useRecoilValue(isMobileSelector);
    const theme = useRecoilValue(themeSelector);
    return (_jsx("li", { className: cn(styles.messageBubble, styles.assistant, styles[theme], {
            [styles.isMobile]: isMobile,
            [className]: !!className,
        }), children: children }));
};
